import { alpha, useTheme } from "@mui/material";
import { createSxStyles } from "../../../common/createSxStyles";

export const useReviewUserResponsibilityDetailDialogStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        entityRole: {
            color: alpha(theme.palette.primary.main, 0.7),
        },
    });
};
